/**
 * 模块名称：
 * @author ：XXXXX
 */
import { Toast } from 'vant'
import wxapi from '@/utils/wxapi.js'
import {
    getJobList,
    queryNoLoginPositionList,
} from '@/api/position'
const state = {
    count: 0,
    jobList: [],
    tabIndex: 1,

    isFirst: false,
}

const mutations = {
    /**
     * 为state项赋值
     * @param state
     * @param data
     */
    setStateItem(state, data) {
        state[data.key] = data.value
    },
}

const actions = {
    /***
     * 我擅长的职位
     */
    async requestJobList({ state, commit }, data) {
        try {
            const res = await getJobList(data)
            if (res.data.code == 200) {
                commit('setStateItem', {
                    key: 'jobList',
                    value: res.data.data.position_list || [],
                })

                commit('setStateItem', {
                    key: 'count',
                    value: res.data.data.total_records,
                })
                commit('setStateItem', { key: 'isFirst', value: true })
                let parames = {
                    title: '上禾蛙hewa.cn，更多职位等你来',
                    dec: '猎头上禾蛙—简历不浪费，职位不白费',
                }
                wxapi(parames)
                return true
            } else {
                commit('setStateItem', { key: 'isFirst', value: true })
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            console.log('>>>>>>>>', e)
            return false
        }
    },
    /**
     * 查询未登录是职位列表
     * @param {*} param0
     * @param {*} data
     * @returns
     */
    async queryNoLoginPositionList({ state, commit }, data) {
        try {
            const res = await queryNoLoginPositionList(data)
            if (res.data.code == 200) {
                commit('setStateItem', {
                    key: 'jobList',
                    value: res.data.data.position_list || [],
                })
                commit('setStateItem', {
                    key: 'count',
                    value: res.data.data.total_records,
                })
                commit('setStateItem', { key: 'isFirst', value: true })
                let parames = {
                    title: '上禾蛙hewa.cn，更多职位等你来',
                    dec: '猎头上禾蛙—简历不浪费，职位不白费',
                }
                wxapi(parames)
                return true
            } else {
                commit('setStateItem', { key: 'isFirst', value: true })
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            console.log('>>>>>>>>', e)
            return false
        }
    },

}

export default {
    state,
    actions,
    mutations,
    namespaced: true,
}
